import Head from 'next/head';
import * as React from 'react';
import Pagination from '../../../domain/valueobjects/Pagination';

interface Props {
  title: string;
  description: string;
  thumbnailUrl: string;
  keywords: string;
  currentUrl: string;
  // tslint:disable-next-line: no-any
  pagination?: Pagination;
  noIndex: boolean;
  opgDisabled: boolean;
}

const MetaTags = (initProps: Partial<Props>) => {
  const defaultProps: Props = {
    title: 'Coubic (クービック) | 人気サービスの検索・予約サイト',
    description:
      '月間250万人以上が利用する検索・予約サイト「クービック」では、フィットネスジム・ヨガ・ピラティス・リラクなど様々なサービスを簡単に予約できます。事業者様は無料でサービス情報を掲載できると共に、180以上の業種に対応した予約システムを7日間無料でご利用頂けます。',
    thumbnailUrl:
      'https://d3jf92lm1e7l6.cloudfront.net/images/shared/merchant_categories/4/600x400.png',
    keywords: '予約, クービック',
    currentUrl: 'https://coubic.com',
    noIndex: false,
    opgDisabled: false,
  };

  const {
    title,
    description,
    thumbnailUrl,
    keywords,
    currentUrl,
    pagination,
    noIndex,
    opgDisabled,
  } = {
    ...defaultProps,
    ...initProps,
  };

  const titleWithSuffix = `${title}${
    title !== defaultProps.title ? ' | Coubic' : ''
  }`;
  const canonicalUrl = currentUrl
    .replace(/\?page=1$/g, '')
    .replace(/\/\?/g, '?')
    .replace(/\/$/, '');
  const baseUrl = currentUrl.replace(/\?.*$/, '');
  const robotsContent = noIndex ? 'noindex, follow, noarchive' : 'noarchive';

  return (
    <Head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <title>{titleWithSuffix}</title>
      <meta content={robotsContent} name="robots" />
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      {!opgDisabled && (
        <>
          <meta property="og:site_name" content={titleWithSuffix} />
          <meta property="og:type" content="website" />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={thumbnailUrl} />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@coubic" />
          <meta name="twitter:title" content={titleWithSuffix} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={thumbnailUrl} />
        </>
      )}
      <link href={canonicalUrl} rel="canonical" />
      {pagination && !pagination.isLast && (
        <link
          rel="next"
          href={`${baseUrl}?page=${pagination.currentPage + 1}`}
        />
      )}
      {pagination && pagination.currentPage !== 1 && (
        <link
          rel="prev"
          href={`${baseUrl}?page=${pagination.currentPage - 1}`}
        />
      )}
    </Head>
  );
};

export default MetaTags;
